export default __webpack_public_path__ + "static/media/advicegradissuegfx-05.ee20c04a.png";